import { Component } from '@angular/core';
import { Location } from '@freelancer/location';
import { ButtonColor, ButtonSize } from '@freelancer/ui/button';
import { HeadingType } from '@freelancer/ui/heading';
import { Margin } from '@freelancer/ui/margin';
import { TextSize } from '@freelancer/ui/text';

@Component({
  selector: 'app-home-page-crowd-favorites',
  template: `
    <fl-bit [flTrackingSection]="'HomePage'">
      <fl-heading
        i18n="Crowd Favorites header"
        [headingType]="HeadingType.H2"
        [size]="TextSize.LARGE"
        [sizeTablet]="TextSize.XLARGE"
        [sizeDesktop]="TextSize.XXXLARGE"
        [flMarginBottom]="Margin.XXSMALL"
        [flMarginBottomTablet]="Margin.XSMALL"
        [flMarginBottomDesktop]="Margin.MID"
      >
        Make it Real with Freelancer.
      </fl-heading>
      <fl-text
        i18n="Crowd Favorites subheader"
        [size]="TextSize.SMALL"
        [sizeTablet]="TextSize.MARKETING_SMALL"
        [sizeDesktop]="TextSize.MID"
        [sizeDesktopXLarge]="TextSize.LARGE"
        [flMarginBottom]="Margin.LARGE"
        [flMarginBottomTablet]="Margin.XLARGE"
      >
        Get some Inspirations from 1800+ skills
      </fl-text>
      <fl-grid
        [flMarginBottom]="Margin.XLARGE"
        [flMarginBottomTablet]="Margin.XXLARGE"
        [flMarginBottomDesktop]="Margin.XXXLARGE"
      >
        <fl-col
          [col]="12"
          [colTablet]="4"
          [colDesktopLarge]="3"
          [flMarginBottom]="Margin.LARGE"
          [flMarginBottomDesktop]="Margin.XLARGE"
        >
          <app-landing-page-showcase-card
            category="Logo Design."
            i18n-category="Logo design category"
            details="$30 USD in 1 day."
            i18n-details="
              Price in US dolllars and duration of logo design portfolio
            "
            indianDetails="₹2,200 in 1 day."
            i18n-indianDetails="
              Price in Indian rupees and duration of logo design portfolio
            "
            [isIndia]="isIndia"
            [imageSource]="'home/crowd-favorite-redesign/logo-design-v2.jpg'"
            [link]="'/discover/logo-design'"
            [trackingLabel]="'CategoryPageLink-LogoDesign'"
          ></app-landing-page-showcase-card>
        </fl-col>
        <fl-col
          [col]="12"
          [colTablet]="4"
          [colDesktopLarge]="3"
          [flMarginBottom]="Margin.LARGE"
          [flMarginBottomDesktop]="Margin.XLARGE"
        >
          <app-landing-page-showcase-card
            category="Package Design."
            i18n-category="Package design category"
            details="$280 USD in 4 days."
            i18n-details="
              Price in US dolllars and duration of package design portfolio
            "
            indianDetails="₹20,400 in 8 days."
            i18n-indianDetails="
              Price in Indian rupees and duration of package design portfolio
            "
            [isIndia]="isIndia"
            [imageSource]="
              'home/crowd-favorite-redesign/package-design-1-v2.jpg'
            "
            [link]="'/discover/package-design'"
            [trackingLabel]="'CategoryPageLink-PackageDesign'"
          ></app-landing-page-showcase-card>
        </fl-col>
        <fl-col
          [col]="12"
          [colTablet]="4"
          [colDesktopLarge]="3"
          [flMarginBottom]="Margin.LARGE"
          [flMarginBottomDesktop]="Margin.XLARGE"
        >
          <app-landing-page-showcase-card
            category="Mobile Design."
            i18n-category="Mobile design category"
            details="$600 USD in 4 days."
            i18n-details="
              Price in US dolllars and duration of mobile design portfolio
            "
            indianDetails="₹43,700 in 4 days."
            i18n-indianDetails="
              Price in Indian rupees and duration of mobile design portfolio
            "
            [isIndia]="isIndia"
            [imageSource]="
              'home/crowd-favorite-redesign/mobile-design-1-v2.jpg'
            "
            [link]="'/discover/mobile-app-development'"
            [trackingLabel]="'CategoryPageLink-MobileDesign'"
          ></app-landing-page-showcase-card>
        </fl-col>
        <fl-col
          [col]="12"
          [colTablet]="4"
          [colDesktopLarge]="3"
          [flMarginBottom]="Margin.LARGE"
          [flMarginBottomDesktop]="Margin.XLARGE"
          [flShowDesktopLarge]="true"
        >
          <app-landing-page-showcase-card
            category="WordPress."
            i18n-category="WordPress category"
            details="$45 USD in 1 day"
            i18n-details="
              Price in US dolllars and duration of WordPress portfolio
            "
            indianDetails="₹3,300 in 1 day"
            i18n-indianDetails="
              Price in Indian rupees and duration of WordPress portfolio
            "
            [isIndia]="isIndia"
            [imageSource]="'home/crowd-favorite-redesign/wordpress-1.jpg'"
            [link]="'/discover/wordpress'"
            [trackingLabel]="'CategoryPageLink-WordPress'"
          ></app-landing-page-showcase-card>
        </fl-col>
        <fl-col
          [col]="12"
          [colTablet]="4"
          [colDesktopLarge]="3"
          [flMarginBottom]="Margin.LARGE"
          [flMarginBottomTablet]="Margin.NONE"
        >
          <app-landing-page-showcase-card
            category="Logo Design."
            i18n-category="Logo design category"
            details="$30 USD in 2 days."
            i18n-details="
              Price in US dolllars and duration of logo design portfolio
            "
            indianDetails="₹2,200 in 2 days."
            i18n-indianDetails="
              Price in Indian rupees and duration of logo design portfolio
            "
            [isIndia]="isIndia"
            [imageSource]="'home/crowd-favorite-redesign/logo-design-1-v2.jpg'"
            [link]="'/discover/logo-design'"
            [trackingLabel]="'CategoryPageLink-LogoDesign'"
          ></app-landing-page-showcase-card>
        </fl-col>
        <fl-col
          [col]="12"
          [colTablet]="4"
          [colDesktopLarge]="3"
          [flMarginBottom]="Margin.LARGE"
          [flMarginBottomTablet]="Margin.NONE"
        >
          <app-landing-page-showcase-card
            category="Website."
            i18n-category="Website category"
            details="$150 USD in 1 day."
            i18n-details="
              Price in US dolllars and duration of website portfolio
            "
            indianDetails="₹10,900 in 1 day."
            i18n-indianDetails="
              Price in Indian rupees and duration of website portfolio
            "
            [isIndia]="isIndia"
            [imageSource]="'home/crowd-favorite-redesign/website-1.jpg'"
            [link]="'/discover/website-design'"
            [trackingLabel]="'CategoryPageLink-WebsiteDesign'"
          ></app-landing-page-showcase-card>
        </fl-col>
        <fl-col [col]="12" [colTablet]="4" [colDesktopLarge]="3">
          <app-landing-page-showcase-card
            category="Product Design."
            i18n-category="Product design category"
            details="$260 USD in 6 days."
            i18n-details="
              Price in US dolllars and duration of product design portfolio
            "
            indianDetails="₹18,900 in 6 days."
            i18n-indianDetails="
              Price in Indian rupees and duration of product design portfolio
            "
            [isIndia]="isIndia"
            [imageSource]="'home/crowd-favorite-redesign/product-design-v2.jpg'"
            [link]="'/discover/product-design'"
            [trackingLabel]="'CategoryPageLink-ProductDesign'"
          ></app-landing-page-showcase-card>
        </fl-col>
        <fl-col
          [col]="12"
          [colTablet]="4"
          [colDesktopLarge]="3"
          [flMarginBottom]="Margin.LARGE"
          [flMarginBottomDesktop]="Margin.XLARGE"
          [flShowDesktopLarge]="true"
        >
          <app-landing-page-showcase-card
            category="Illustration."
            i18n-category="Illustration category"
            details="$10 USD in 3 days."
            i18n-details="
              Price in US dolllars and duration of illustration portfolio
            "
            indianDetails="₹730 in 3 days."
            i18n-indianDetails="
              Price in Indian rupees and duration of illustration portfolio
            "
            [isIndia]="isIndia"
            [imageSource]="'home/crowd-favorite-redesign/illustration-v2.jpg'"
            [link]="'/discover/illustration'"
            [trackingLabel]="'CategoryPageLink-Illustration'"
          ></app-landing-page-showcase-card>
        </fl-col>
        <fl-col
          [col]="12"
          [colTablet]="4"
          [colDesktopLarge]="3"
          [flMarginBottom]="Margin.LARGE"
          [flMarginBottomDesktop]="Margin.XLARGE"
          [flShowDesktopLarge]="true"
        >
          <app-landing-page-showcase-card
            category="WordPress."
            i18n-category="WordPress category"
            details="$150 USD in 18 days."
            i18n-details="
              Price in US dolllars and duration of WordPress portfolio
            "
            indianDetails="₹10,900 in 18 days."
            i18n-indianDetails="
              Price in Indian rupees and duration of WordPress portfolio
            "
            [isIndia]="isIndia"
            [imageSource]="'home/crowd-favorite-redesign/wordpress-2.jpg'"
            [link]="'/discover/wordpress'"
            [trackingLabel]="'CategoryPageLink-WordPress'"
          ></app-landing-page-showcase-card>
        </fl-col>
        <fl-col
          [col]="12"
          [colTablet]="4"
          [colDesktopLarge]="3"
          [flMarginBottom]="Margin.LARGE"
          [flMarginBottomDesktop]="Margin.XLARGE"
          [flShowDesktopLarge]="true"
        >
          <app-landing-page-showcase-card
            category="Package Design."
            i18n-category="Package design category"
            details="$50 USD in 10 days."
            i18n-details="
              Price in US dolllars and duration of package design portfolio
            "
            indianDetails="₹3,600 in 10 days."
            i18n-indianDetails="
              Price in Indian rupees and duration of package design portfolio
            "
            [isIndia]="isIndia"
            [imageSource]="
              'home/crowd-favorite-redesign/package-design-2-v2.jpg'
            "
            [link]="'/discover/package-design'"
            [trackingLabel]="'CategoryPageLink-PackageDesign'"
          ></app-landing-page-showcase-card>
        </fl-col>
        <fl-col
          [col]="12"
          [colTablet]="4"
          [colDesktopLarge]="3"
          [flMarginBottom]="Margin.LARGE"
          [flMarginBottomDesktop]="Margin.XLARGE"
          [flShowDesktopLarge]="true"
        >
          <app-landing-page-showcase-card
            category="Mobile Design."
            i18n-category="Mobile design category"
            details="$100 USD in 1 day."
            i18n-details="
              Price in US dolllars and duration of mobile design portfolio
            "
            indianDetails="₹7,300 in 1 day."
            i18n-indianDetails="
              Price in Indian rupees and duration of mobile design portfolio
            "
            [isIndia]="isIndia"
            [imageSource]="
              'home/crowd-favorite-redesign/mobile-design-2-v2.jpg'
            "
            [link]="'/discover/mobile-app-development'"
            [trackingLabel]="'CategoryPageLink-MobileDesign'"
          ></app-landing-page-showcase-card>
        </fl-col>
        <fl-col
          [col]="12"
          [colTablet]="4"
          [colDesktopLarge]="3"
          [flMarginBottom]="Margin.LARGE"
          [flMarginBottomDesktop]="Margin.XLARGE"
          [flShowDesktopLarge]="true"
        >
          <app-landing-page-showcase-card
            category="Package Design."
            i18n-category="Package design category"
            details="$155 USD in 2 days."
            i18n-details="
              Price in US dolllars and duration of package design portfolio
            "
            indianDetails="₹11,300 in 2 days."
            i18n-indianDetails="
              Price in Indian rupees and duration of package design portfolio
            "
            [isIndia]="isIndia"
            [imageSource]="'home/crowd-favorite-redesign/package-design-3.jpg'"
            [link]="'/discover/package-design'"
            [trackingLabel]="'CategoryPageLink-PackageDesign'"
          ></app-landing-page-showcase-card>
        </fl-col>
        <fl-col
          [col]="12"
          [colTablet]="4"
          [colDesktopLarge]="3"
          [flMarginBottom]="Margin.LARGE"
          [flMarginBottomDesktop]="Margin.NONE"
          [flShowDesktopLarge]="true"
        >
          <app-landing-page-showcase-card
            category="Website."
            i18n-category="Website category"
            details="$200 USD in 9 days."
            i18n-details="
              Price in US dolllars and duration of website portfolio
            "
            indianDetails="₹14,600 in 9 days."
            i18n-indianDetails="
              Price in Indian rupees and duration of website portfolio
            "
            [isIndia]="isIndia"
            [imageSource]="'home/crowd-favorite-redesign/website-2.jpg'"
            [link]="'/discover/website-design'"
            [trackingLabel]="'CategoryPageLink-WebsiteDesign'"
          ></app-landing-page-showcase-card>
        </fl-col>
        <fl-col
          [col]="12"
          [colTablet]="4"
          [colDesktopLarge]="3"
          [flMarginBottom]="Margin.LARGE"
          [flMarginBottomDesktop]="Margin.NONE"
          [flShowDesktopLarge]="true"
        >
          <app-landing-page-showcase-card
            category="3D Modeling."
            i18n-category="3D modeling category"
            details="$110 USD in 28 days."
            i18n-details="
              Price in US dolllars and duration of 3D modeling portfolio
            "
            indianDetails="₹8,000 in 3 days."
            i18n-indianDetails="
              Price in Indian rupees and duration of 3D modeling portfolio
            "
            [isIndia]="isIndia"
            [imageSource]="'home/crowd-favorite-redesign/3d-modeling.jpg'"
            [link]="'/discover/3d-modeling'"
            [trackingLabel]="'CategoryPageLink-3DModeling'"
          ></app-landing-page-showcase-card>
        </fl-col>
        <fl-col
          [col]="12"
          [colTablet]="4"
          [colDesktopLarge]="3"
          [flMarginBottom]="Margin.LARGE"
          [flMarginBottomDesktop]="Margin.NONE"
          [flShowDesktopLarge]="true"
        >
          <app-landing-page-showcase-card
            category="Graphic Design."
            i18n-category="Graphic design category"
            details="$111 USD in 8 days."
            i18n-details="
              Price in US dolllars and duration of graphic design portfolio
            "
            indianDetails="₹8,100 in 8 days."
            i18n-indianDetails="
              Price in Indian rupees and duration of graphic design portfolio
            "
            [isIndia]="isIndia"
            [imageSource]="'home/crowd-favorite-redesign/graphic-design-1.jpg'"
            [link]="'/discover/graphic-design'"
            [trackingLabel]="'CategoryPageLink-GraphicDesign'"
          ></app-landing-page-showcase-card>
        </fl-col>
        <fl-col
          [col]="12"
          [colTablet]="4"
          [colDesktopLarge]="3"
          [flMarginBottom]="Margin.LARGE"
          [flMarginBottomDesktop]="Margin.NONE"
          [flShowDesktopLarge]="true"
        >
          <app-landing-page-showcase-card
            category="Graphic Design."
            i18n-category="Graphic design category"
            details="$60 USD in 10 days."
            i18n-details="
              Price in US dolllars and duration of graphic design portfolio
            "
            indianDetails="₹4,400 in 3 days."
            i18n-indianDetails="
              Price in Indian rupees and duration of graphic design portfolio
            "
            [isIndia]="isIndia"
            [imageSource]="'home/crowd-favorite-redesign/graphic-design-2.jpg'"
            [link]="'/discover/graphic-design'"
            [trackingLabel]="'CategoryPageLink-GraphicDesign'"
          ></app-landing-page-showcase-card>
        </fl-col>
      </fl-grid>
      <fl-bit class="CrowdFavorites-button">
        <fl-button
          flTrackingLabel="CategoryPageButton"
          i18n="Link to the category page"
          [color]="ButtonColor.PRIMARY_PINK"
          [link]="'/discover'"
          [size]="ButtonSize.LARGE"
        >
          View More Projects
        </fl-button>
      </fl-bit>
    </fl-bit>
  `,
  styleUrls: ['./crowd-favorites.component.scss'],
})
export class HomePageCrowdFavoritesComponent {
  ButtonColor = ButtonColor;
  ButtonSize = ButtonSize;
  Margin = Margin;
  HeadingType = HeadingType;
  TextSize = TextSize;

  isIndia: boolean = this.isIndiaDomain(this.location);

  constructor(private location: Location) {}

  isIndiaDomain(location: Location): boolean {
    const found = location.hostname.match(/freelancer.in/);
    return found ? found.length > 0 : false;
  }
}
